import { useState } from "react"
import { useHistory, useParams } from "react-router-dom";
import arrayUtilities from "../../utilities/arrayUtilities"
import { ConfigurationUpdate } from "../shared/configurationUpdate"
export const CameraAllRois = ({ roiData, handleDelete, organisationId, siteId, cameraId, canUpdateRoi }) => {
    const history = useHistory();
    const [roi, setRoi] = useState(null)

    return <ConfigurationUpdate
        dataTarget="camera-roi"
        headerButtonText="Add"
        id="regions-of-interest"
        title="Regions of Interest"
        handleHeaderAction={ () => history.push(`/organisation/${organisationId}/site/${siteId}/camera/${cameraId}/roi`) }
        isActionAllowed={canUpdateRoi}
    >
        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
            <thead className="bg-200 text-900">
                <tr>
                    <th>Name</th>
                    <th className="text-right">&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                {
                    !arrayUtilities.isNullOrEmpty(roiData) && roiData.map(
                        item => <tr key={item.id}>
                            <td>{ item.name }</td>
                            {canUpdateRoi && <td className="text-right">
                                <button onClick={ () => history.push(`/organisation/${organisationId}/site/${siteId}/camera/${cameraId}/roi/${item.id}`) } className='btn p-0'><i className="fas fa-edit mr-2"></i></button>
                                <button onClick={ () => setRoi(item) } data-toggle="modal" data-target="#delete-roi-modal" className='btn p-0'><i className="fas fa-trash-alt"></i></button>
                            </td>}
                        </tr>
                    )
                }
            </tbody>
        </table>
        {
            roi && canUpdateRoi &&
            <div className="modal fade" id="delete-roi-modal" tabIndex="-1" role="dialog" aria-labelledby="delete-roi-modal-Label" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="delete-roi-modal-Label">Are you sure you want to delete this region of interest?</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-footer">
                            <button onClick={ () => setRoi(null) } type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                            <button
                                type="button"
                                className="btn btn-danger btn-sm ml-2"
                                data-dismiss="modal"
                                onClick={ () => handleDelete(roi) }
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        }
    </ConfigurationUpdate>
}